// extracted by mini-css-extract-plugin
module.exports = {"container":"Students_container__1kR05","tableContainer":"Students_tableContainer__3Anl9","searchbar":"Students_searchbar__1oQnR","studentsTable":"Students_studentsTable__1HvTU"};